'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$resource',
                function($resource) {
                    return $resource('api/settings', null, {
                        getValueByType: {url: 'api/settings/get-by-current-user', method: 'GET'},
                        setValueForType: {url: 'api/settings/set-by-current-user', method: 'POST'},
                        getAvailableValuesByType: {url: 'api/settings/available-values', method: 'GET'},
                    });
                }];
